module.exports = __webpack_public_path__ + "media/dog-weight/cockapoo-white-bf51933e.svg";